
export let saveSignTableLabels = [
  {
    label: '产妇姓名',
    value: 'genericFormData.data.name'
  },
  {
    label: '手机号',
    minWidth: 110,
    value: 'genericFormData.data.phone'
  },
  // {
  //   label: '证件类型',
  //   value: 'identityCard_type'
  // },
  {
    label: '母亲证件号',
    minWidth: 170,
    value: 'genericFormData.data.certificateNumber'
  },
  {
    label: '常住地区',
    minWidth: 150,
    value: 'address_show'
  },
  {
    label: '微信号',
    minWidth: 110,
    value: 'genericFormData.data.wechatNumber'
  },
  {
    label: '预产期',
    minWidth: 110,
    value: 'date_of_childbirth'
  },
  {
    label: '产检医院',
    minWidth: 120,
    value: 'hospitalName'
  },
  {
    label: '选择优惠',
    value: 'userOption.remark'
  },
  {
    label: '活动名称',
    value: 'eventName'
  },
  {
    label: '定金',
    value: 'promotion_amount'
  },
  {
    label: '预约时间',
    minWidth: 140,
    value: 'registration_time'
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]
export let storeFilterLabels = [
  // {
  //   label: '报名时间',
  //   type: 'time-slot',
  //   clearable: true,
  //   startName: 'startTime',
  //   endName: 'endTime',
  //   value: 'signTime'
  // },
  {
    label: '预约状态',
    type: 'select',
    clearable: true,
    options: [
      {
        label: '待支付',
        value: 'WAIT_FOR_PAY'
      },
      {
        label: '已预约',
        value: 'SUCCESS'
      },
      {
        label: '已取消',
        value: 'CANCEL'
      }
    ],
    value: 'userRegistrationStatus'
  }
]
export let IMMUNE_CELL_STORAGELabels=[
  {
    label: '姓名',
    value: 'genericFormData.data.name'
	},
	{
    label: '电话号码',
    value: 'genericFormData.data.mobile'
  },
	{
    label: '年龄',
    value: 'genericFormData.data.age'
	},
	{
    label: '地区',
    value: 'address_show'
	},
]
